var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 8.08301C3.01117 8.08301 2.75 8.34418 2.75 8.66634V13.333C2.75 13.6552 3.01117 13.9163 3.33333 13.9163H12.6667C12.9888 13.9163 13.25 13.6552 13.25 13.333V8.66634C13.25 8.34418 12.9888 8.08301 12.6667 8.08301H3.33333ZM1.25 8.66634C1.25 7.51575 2.18274 6.58301 3.33333 6.58301H12.6667C13.8173 6.58301 14.75 7.51575 14.75 8.66634V13.333C14.75 14.4836 13.8173 15.4163 12.6667 15.4163H3.33333C2.18274 15.4163 1.25 14.4836 1.25 13.333V8.66634Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 2.08301C7.31494 2.08301 6.65786 2.35518 6.17339 2.83965C5.68892 3.32412 5.41675 3.9812 5.41675 4.66634V7.33301C5.41675 7.74722 5.08096 8.08301 4.66675 8.08301C4.25253 8.08301 3.91675 7.74722 3.91675 7.33301V4.66634C3.91675 3.58337 4.34696 2.54476 5.11273 1.77899C5.8785 1.01321 6.91711 0.583008 8.00008 0.583008C9.08305 0.583008 10.1217 1.01321 10.8874 1.77899C11.6532 2.54476 12.0834 3.58337 12.0834 4.66634V7.33301C12.0834 7.74722 11.7476 8.08301 11.3334 8.08301C10.9192 8.08301 10.5834 7.74722 10.5834 7.33301V4.66634C10.5834 3.9812 10.3112 3.32412 9.82677 2.83965C9.3423 2.35518 8.68522 2.08301 8.00008 2.08301Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.570fb1c206dcade90007fa9334ea812c.svg";
export { ForwardRef as ReactComponent };